import type { ISkuSelectPopupShowData } from '../models';
import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import SkuSelectPopup from '../ui/SkuSelectPopup.vue';

const { createPopup } = usePopups();
const skuSelectPopup = createPopup({
  component: SkuSelectPopup,
});

async function showSkuSelectPopup(data: ISkuSelectPopupShowData) {
  if (skuSelectPopup.isShown) {
    skuSelectPopup.close();
    setTimeout(() => skuSelectPopup.show(data), 200);
    return;
  }

  skuSelectPopup.show(data);
}

export { showSkuSelectPopup };
